export default {
  whitelists: state => state.whitelists,
  whitelist: state => state.whitelist,
  sortedWhitelists: state => {
    const whitelists = [...state.whitelists]
    whitelists.sort((a, b) => {
      if (a.IsFavorite && !b.IsFavorite) return -1
      if (!a.IsFavorite && b.IsFavorite) return 1
      if (a.Name < b.Name) return -1
      if (a.Name > b.Name) return 1
      return 0
    })
    return whitelists
  },
  currentWhitelistId: state => Number(state.currentWhitelistId),
  availabilityInfo: state => state.availabilityInfo,
  whitelistsLoaded: state => state.whitelistsLoaded,
  activeUsers: state => {
    const now = new Date()
    return (state.whitelist.Users || []).filter(user => {
      const validFrom = new Date(user.ValidFrom)
      const validTo = new Date(user.ValidTo)

      const hasNoValidTo =
        user.ValidTo === '0001-01-01T00:00:00Z' || !user.ValidTo

      const isValidToInFuture = validTo > now
      const isValidFromInPast = validFrom <= now

      return isValidFromInPast && (hasNoValidTo || isValidToInFuture)
    })
  },

  inactiveUsers: state => {
    const now = new Date()
    return (state.whitelist.Users || []).filter(user => {
      const validFrom = new Date(user.ValidFrom)
      const validTo = new Date(user.ValidTo)

      const hasValidTo = user.ValidTo && user.ValidTo !== '0001-01-01T00:00:00Z'

      const isValidToInPast = hasValidTo && validTo <= now
      const isValidFromInFuture = validFrom > now

      return isValidToInPast || isValidFromInFuture
    })
  },

  filteredWhitelists: (state, getters) => term => {
    const q = (term || '').trim().toLowerCase()
    const base = getters.sortedWhitelists
    if (!q) return base
    return base.filter(wl => {
      const name = (wl.Name || '').toLowerCase()
      const region = (wl.Region || '').toLowerCase()
      const validIn = (wl.ValidIn || '').toLowerCase()
      return name.includes(q) || region.includes(q) || validIn.includes(q)
    })
  },
  safeCurrentPage: (state, getters) => term => {
    const list = getters.filteredWhitelists(term)
    const total = Math.max(1, Math.ceil(list.length / state.pageSize))
    return Math.min(state.currentPage, total - 1)
  },
  pagedWhitelists: (state, getters) => term => {
    const list = getters.filteredWhitelists(term)
    const safePage = getters.safeCurrentPage(term)
    const start = safePage * state.pageSize
    return list.slice(start, start + state.pageSize)
  },

  totalPages: (state, getters) => term => {
    const total = getters.filteredWhitelists(term).length
    return Math.max(1, Math.ceil(total / state.pageSize))
  }
}
